/**
 * What the stored status list says about one credential.
 *
 * The list is fetched and its signature checked by `sync.ts` before it is
 * stored, so this reads it as settled. It answers from whatever the device
 * holds, however old, and says how old: the verifier shows that age rather
 * than pretending to know about a revocation made after the last sync.
 */
import { isRevoked } from "./format";

/** The part of a verified list a verifier needs. */
export interface StoredStatusList {
  bitmap: Uint8Array;
  issuedAt: number;
}

export interface StatusAnswer {
  /** `beyond`: the credential was issued after the list, which says nothing
   *  about it. `unknown`: there is no list on this device. */
  state: "valid" | "revoked" | "beyond" | "unknown";
  listIssuedAt?: number;
}

/** Pure, and handed the list rather than loading it, so the scan screen reads
 *  storage once and `verifyPresentation` stays synchronous about status. */
export function checkStatus(list: StoredStatusList | null, index: number): StatusAnswer {
  if (list === null) return { state: "unknown" };
  const revoked = isRevoked(list.bitmap, index);
  const state = revoked === "beyond" ? "beyond" : revoked ? "revoked" : "valid";
  return { state, listIssuedAt: list.issuedAt };
}
